import { combineReducers } from 'redux';
import matchDataReducer from './matchReducer';
import liveDataReducer from './liveReducer';
import pageReducer from './pageReducer';
import workerReducer from './workerReducer';
import connexionReducer from './connexionReducer';

const rootReducer = combineReducers({matchDataReducer, liveDataReducer, pageReducer, workerReducer, connexionReducer});

export default rootReducer;